import { useEffect } from "react";
import useHistory from "routing/useHistory";
import gmailRoutes from "./common/Routes";
const GmailInputConfiguration = ({
  url = gmailRoutes.INTEGRATIONS.Gmail.ACTIVITYAPI.index
}) => {
  const history = useHistory();
  useEffect(() => {
    history.push(url);
  }, [history, url]);
  return null;
};
export default GmailInputConfiguration;
